import {
  doc,
  getFirestore,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore';

export default function updateTestStandLog(testLogId, patch) {
  return updateDoc(doc(getFirestore(), 'test_stand_logs', testLogId), {
    ...patch,
    updatedAt: serverTimestamp(),
  });
}
